export const pascalCaseWords = (input: string): string => {
    const words = input.split(/\s+/);
    const formattedWords = words.map((word) => {
        if (word.includes('-')) {
            const parts = word.split('-');

            return parts
                .map((part) => {
                    return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
                })
                .join('-');
        }

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    return formattedWords.join(' ');
};
